import { render, staticRenderFns } from "./view.vue?vue&type=template&id=5d8dc255"
import script from "./view.ts?vue&type=script&lang=js&external"
export * from "./view.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d8dc255')) {
      api.createRecord('5d8dc255', component.options)
    } else {
      api.reload('5d8dc255', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=5d8dc255", function () {
      api.rerender('5d8dc255', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/statusPCP/manipulacao/view.vue"
export default component.exports